import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
    selector: 'app-input-formulario',
    templateUrl: './input-formulario.component.html',
    styleUrls: ['./input-formulario.component.scss'],
    standalone: true,
})
export class InputFormularioComponent implements ControlValueAccessor {

    @Input() inputId: string = '';
    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input() inputmode: string = 'text';
    @Input() tipo: string = 'text';
    @Input() longitudMaxima?: number;
    @Input() soloLectura: boolean = false;
    @Input() prevenirPegar: boolean = false;
    @Input() prevenirMenuContextual: boolean = false;
    @Input() patronValidacion?: RegExp;

    valor: string = '';
    deshabilitado = false;

    // Funciones para ControlValueAccessor
    private alCambiar: (value: any) => void = () => { };
    private alTocar: () => void = () => { };

    constructor(
        @Optional() @Self() private readonly control?: NgControl
    ) {
        if (control) {
            control.valueAccessor = this;
        }
    }

    // Implementación de ControlValueAccessor
    writeValue(value: any): void {
        this.valor = value || '';
    }

    registerOnChange(fn: any): void {
        this.alCambiar = fn;
    }

    registerOnTouched(fn: any): void {
        this.alTocar = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.deshabilitado = isDisabled;
    }

    alCambiarInput(event: Event): void {
        const valorInput = (event.target as HTMLInputElement).value;
        this.valor = valorInput;
        this.alCambiar(valorInput);
    }

    alPresionarTecla(event: KeyboardEvent): boolean {
        if (this.patronValidacion) {
            const caracter = event.key;
            if (!this.patronValidacion.test(caracter)) {
                event.preventDefault();
                return false;
            }
        }
        return true;
    }

    alPegar(event: ClipboardEvent): boolean {
        if (this.prevenirPegar) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    alMenuContextual(event: MouseEvent): boolean {
        if (this.prevenirMenuContextual) {
            event.preventDefault();
            return false;
        }
        return true;
    }
}
